import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { Button } from '@material-ui/core';
import styles from './Button.styles';
import ButtonPropTypes from './Button.model';
import { FormattedMessage } from 'components/DynamicFormattedMessage';

const useStyles = makeStyles(styles);

export const Component = props => {
  const {
    isPrimary,
    color,
    text,
    fullWidth,
    size,
    href,
    disabled,
    icon,
    anchor = 'left',
    ...rest
  } = props;

  const classes = useStyles({ size, ...rest });
  return (
    <Button
      color={color}
      variant={isPrimary ? 'contained' : 'text'}
      className={isPrimary ? classes.primaryBtn : classes.secondaryBtn}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      href={href}
      data-cmp="Button"
      {...rest}
    >
      {icon && anchor === 'left' && icon}
      {text && <FormattedMessage id={text} />}
      {icon && anchor === 'right' && icon}
    </Button>
  );
};

Component.propTypes = ButtonPropTypes;

Component.defaultProps = {
  isPrimary: true,
  color: 'primary',
  size: 'medium',
  disabled: false,
  fullWidth: false,
  href: undefined,
};

export default Component;
